module.exports = "<div class=\"order-fields-page\">\n    <div class=\"row\">\n        <div class=\"col-md-12\">\n            <div class=\"panel panel-default blnd-panel\">\n                <div class=\"panel-body\">\n                    <blnd-upload-section ng-model=\"vm.customer\" type=\"customer\"></blnd-upload-section>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/customers/files.html
// module id = 714
// module chunks = 0